import React from 'react';
import type { IconPropsSVG } from './types';

export function Gate(props: IconPropsSVG): React.JSX.Element {
    return (
        <svg
            viewBox="0 0 512 512"
            {...props}
        >
            <path
                fill="currentColor"
                d="M462,226c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10S467.52,226,462,226z"
            />
            <path
                fill="currentColor"
                d="M50,226c-5.52,0-10,4.48-10,10s4.48,10,10,10s10-4.48,10-10S55.52,226,50,226z"
            />
            <path
                fill="currentColor"
                d="M502,126h-0.027C508.265,117.637,512,107.248,512,96c0-27.57-22.43-50-50-50s-50,22.43-50,50
		c0,11.248,3.735,21.637,10.027,30H422c-5.522,0-10,4.478-10,10v50.03c-7.399,0.025-17.158,0.065-23,0.113V166.63
		c0-5.522-4.478-10-10-10c-5.522,0-10,4.478-10,10v12.435c-0.931-0.964-1.899-2.045-2.923-3.258
		c-10.745-12.754-24.515-23.761-40.077-32.106V121.83c0-5.522-4.478-10-10-10c-5.522,0-10,4.478-10,10v12.983
		c-12.92-4.643-26.438-7.5-40-8.448V96c0-5.522-4.478-10-10-10c-5.522,0-10,4.478-10,10v30.365
		c-13.565,0.948-27.084,3.807-40,8.452V120.17c0-5.522-4.477-10-10-10s-10,4.478-10,10v23.542
		c-15.764,8.457-29.695,19.652-40.55,32.652c-0.758,0.908-1.587,1.755-2.45,2.566v-12.3c0-5.522-4.477-10-10-10s-10,4.478-10,10
		v20.385c-4.189,0.067-14.913,0.05-23,0.024V136c0-5.522-4.477-10-10-10h-0.027C96.265,117.637,100,107.248,100,96
		c0-27.57-22.43-50-50-50S0,68.43,0,96c0,11.248,3.735,21.637,10.027,30H10c-5.523,0-10,4.478-10,10v320c0,5.522,4.477,10,10,10h80
		c5.523,0,10-4.478,10-10v-11h312v11c0,5.522,4.478,10,10,10h80c5.522,0,10-4.478,10-10V136C512,130.478,507.522,126,502,126z
		 M80,446H20V146h20v50c0,5.522,4.477,10,10,10s10-4.478,10-10v-50h20V446z M50,126c-16.542,0-30-13.458-30-30s13.458-30,30-30
		s30,13.458,30,30S66.542,126,50,126z M123,425h-23v-19h23V425z M123,386h-23V247h23V386z M123,227h-23v-19.959
		c3.808,0.011,8.197,0.022,12.244,0.022c4.378,0,8.351-0.012,10.756-0.046V227z M186,425h-43v-19h43V425z M186,276v40v70h-43
		V244.817c16.149-3.513,31.29-11.046,43-21.321V276z M186,194.605c-2.373,2.327-4.659,4.785-6.815,7.365
		c-8.521,10.2-21.771,18.214-36.185,22.224v-21.525c6.846-3.098,13.007-7.736,17.806-13.49c7.006-8.391,15.56-15.917,25.194-22.232
		V194.605z M206,156.285c12.757-5.415,26.344-8.765,40-9.871v20.099c-14.162,1.416-27.777,5.83-40,12.895V156.285z M206,203.562
		c11.538-9.26,25.37-15.088,40-16.922V266h-40V203.562z M246,425h-40v-19h40V425z M246,386h-40v-60h40V386z M306,425h-40v-19h40
		V425z M306,386h-40v-60h40V386z M306,306H206v-20h100V306z M306,266h-40v-79.359c14.617,1.835,28.449,7.664,40,16.924V266z
		 M306,179.418c-12.232-7.071-25.847-11.487-40-12.904v-20.1c13.651,1.106,27.238,4.454,40,9.865V179.418z M369,425h-43v-19h43V425
		z M369,386h-43v-70v-40v-52.635c11.722,10.137,26.674,17.329,43,20.634V386z M369,223.458
		c-14.663-3.788-27.83-11.575-36.517-21.887c-2.039-2.417-4.216-4.742-6.483-6.965v-27.672c9.465,6.201,17.88,13.567,24.789,21.767
		c4.64,5.496,10.324,11.234,18.211,14.57V223.458z M412,425h-23v-19h23V425z M412,386h-23V246h23V386z M412,226h-23v-19.856
		c5.683-0.048,15.526-0.088,23-0.113V226z M492,446h-60V146h20v50c0,5.522,4.478,10,10,10c5.522,0,10-4.478,10-10v-50h20V446z
		 M462,126c-16.542,0-30-13.458-30-30s13.458-30,30-30s30,13.458,30,30S478.542,126,462,126z"
            />
        </svg>
    );
}
